module.exports = "./img/69fb3ca7360d44585e4add2f2289e58c.jpg";